import React from "react";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import MdCheckbox from "@material-ui/core/Checkbox";
import { useField, useFormikContext } from "formik";

interface CheckboxProps {
  label: string;
  disabled?: boolean;
  name: string;
}
const Checkbox = ({ label, disabled, name }: CheckboxProps) => {
  const [field] = useField(name);
  const { isSubmitting } = useFormikContext();

  return (
    <FormControlLabel
      control={
        <MdCheckbox
          checked={field.value}
          onChange={field.onChange}
          onBlur={field.onBlur}
          name={name}
          disabled={disabled || isSubmitting}
        />
      }
      label={label}
    />
  );
};
Checkbox.defaultProps = {
  disabled: false,
};

export default Checkbox;
